import {AccountNav, LandingNav, LandingNavHome, SupplierNav} from "./navs";
import {
  AccountWithType,
  AccountWithUserType,
  hasOwnerAccess,
  hasValidUserType,
  isBuyerAccount,
  isSupplierAccount
} from "../../util/AccountUtils";
import {UserType} from "../../components/constants/securspace-constants";

export interface NavItem {
  path: string;
  label: string;
}

interface NavItemWithSubmenu {
  path: string;
  label: string;
  submenus: NavItem[];
}

export type NavArray = Array<NavItem | NavItemWithSubmenu>;

export const LEFT_NAV: NavItem[] = [
  LandingNav.LIST_YOUR_LOCATION,
  SupplierNav.GMS_LANDING,
]

export const LEFT_NAV_HOME: NavItem[] = [
  LandingNavHome.LIST_YOUR_LOCATION,
  SupplierNav.GMS_LANDING,
]

export const LEFT_NAV_LOGIN: NavItem[] = [
  LandingNav.LIST_YOUR_LOCATION,
  SupplierNav.GMS_LANDING,
]

export const RIGHT_NAV: NavArray = [
  {
    path: 'register', label: 'Register',
    submenus: [
      LandingNav.REGISTER_AS_CUSTOMER,
      LandingNav.REGISTER_AS_PARTNER,
    ]
  },
  LandingNav.LOG_IN,
]

export const LOGGED_CUSTOMER_ACCOUNT: NavItemWithSubmenu[] = [
  {
    path: 'account', label: 'Account',
    submenus: [
      AccountNav.COMPANY_PROFILE,
      AccountNav.PAYMENT_METHODS_BUYER,
      AccountNav.USER_MANAGEMENT,
      AccountNav.NOTIFICATIONS_SETTINGS,
      AccountNav.SIGN_OUT
    ]
  }
]

export const LOGGED_PARTNER_ACCOUNT: NavItemWithSubmenu[] = [
  {
    path: 'account', label: 'Account',
    submenus: [
      AccountNav.COMPANY_PROFILE,
      AccountNav.PAYOUT_ACCOUNT_PARTNER,
      AccountNav.LOCATIONS_PROFILE,
      AccountNav.API_INTEGRATION,
      AccountNav.USER_MANAGEMENT,
      AccountNav.NOTIFICATIONS_SETTINGS,
      AccountNav.SIGN_OUT
    ]
  }
]

export const LOGGED_IN_LOWER_USER: NavItemWithSubmenu[] = [
  {
    path: 'account', label: 'Account',
    submenus: [
      AccountNav.SIGN_OUT
    ]
  }
]

export const LOGGED_IN_GATE_MANAGER: NavItemWithSubmenu[] = [
  {
    path: 'account', label: 'Account',
    submenus: [
      AccountNav.LOCATIONS_PROFILE,
      AccountNav.SIGN_OUT
    ]
  }
]

export const determineRightNav = (user?: (AccountWithUserType & AccountWithType) | null): NavArray => {
  if (hasOwnerAccess(user)) {
    if (isSupplierAccount(user)) {
      return LOGGED_PARTNER_ACCOUNT
    } else if (isBuyerAccount(user)) {
      return LOGGED_CUSTOMER_ACCOUNT
    }
  } else if (user?.userType === UserType.GATE_MANAGER) {
    return LOGGED_IN_GATE_MANAGER
  } else if (hasValidUserType(user)) {
    return LOGGED_IN_LOWER_USER
  } else {
    return RIGHT_NAV;
  }
  return [];
}
